jQuery(window).load(function(){
  	//jQuery('.js_prod_sub').slick('unslick');
	//jQuery('.js_prod_sub').slick('slickSetOption', 'touchThreshold', 5);
  	//console.log(jQuery('.js_prod_sub').get(0).slick.options);
    function openWin() {

    }



});

jQuery(document).ready(function(){
  jQuery('.wp-float-btn a').click(function(){
    myWindow = window.open("https://wa.me/+40740338343", "myWindow", "width=500,height=500");
	/*if (window.matchMedia("(max-width: 981px)").matches) {
    	setTimeout(closeWin, 2000);
    }*/
  });
});

    function closeWin() {
        myWindow.close();
    }

jQuery(window).on('load resize', function(){
	sameHeight('.section-product-v2 .img-responsive');
  	sameHeight('#shopify-section-collection-template .product .img-responsive');
});

function sameHeight(element) {
   	let product_img_height = 0;
    jQuery(element).each(function(){
      let actual_height = jQuery(this).height();
      if(actual_height > product_img_height) {
       product_img_height = actual_height; 
      }
    });
  	jQuery(element).css('height', product_img_height + "px");
}